import { render, staticRenderFns } from "./shopWithdraw.vue?vue&type=template&id=13beafd2&scoped=true"
import script from "./shopWithdraw.vue?vue&type=script&lang=js"
export * from "./shopWithdraw.vue?vue&type=script&lang=js"
import style0 from "./shopWithdraw.vue?vue&type=style&index=0&id=13beafd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13beafd2",
  null
  
)

export default component.exports